import { render, staticRenderFns } from "./ProviderNotificationEdit.vue?vue&type=template&id=dcb9cc72&"
import script from "./ProviderNotificationEdit.vue?vue&type=script&lang=js&"
export * from "./ProviderNotificationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports